export default "__VITE_ASSET__sIyxCiBS__"